import { Capacitor } from "@capacitor/core";

/**
 * Detect if the app is running inside a native Capacitor container.
 *
 * Why: Capacitor.isNativePlatform() can be false when using live-reload (https URL)
 * even though the runtime is native.
 */
export const isNativeApp = (): boolean => {
  if (typeof window === "undefined") return false;

  const protocol = window.location.protocol;
  const ua = navigator.userAgent || "";

  // Native runtime often injects "Capacitor" in the user agent
  const uaSaysCapacitor = /capacitor/i.test(ua);

  // Some builds run on capacitor://localhost or file://
  const protocolSaysNative = protocol === "capacitor:" || protocol === "file:";

  // Canonical Capacitor check (works in most cases)
  const capacitorSaysNative = Capacitor.isNativePlatform();
  
  // iOS app in WKWebView - check for standalone mode or Capacitor platform
  const isCapacitorPlatformNative = Capacitor.getPlatform() !== "web";
  
  // Check for iOS standalone mode (added to home screen or native app)
  const isIOSStandalone = 
    (window.navigator as any).standalone === true ||
    window.matchMedia("(display-mode: standalone)").matches;

  return uaSaysCapacitor || protocolSaysNative || capacitorSaysNative || isCapacitorPlatformNative || isIOSStandalone;
};

/**
 * Get the current platform (ios, android, or web)
 */
export const getNativePlatform = (): "ios" | "android" | "web" => {
  return Capacitor.getPlatform() as "ios" | "android" | "web";
};
